import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export function LogoutButton() {
  const t = useTranslations('consultantAuth.guards');
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate('/auth');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className="absolute top-4 right-4"
      onClick={handleLogout}
    >
      <LogOut className="h-4 w-4 mr-2" />
      {t('logout')}
    </Button>
  );
}
